import { render, staticRenderFns } from "./DashboardTodayIssueSolving.vue?vue&type=template&id=d37f3dbe"
import script from "./DashboardTodayIssueSolving.vue?vue&type=script&lang=ts"
export * from "./DashboardTodayIssueSolving.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports